var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoDespacho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 19",
    style: {
      enableBackground: "new 0 0 26 19"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.3,7.3l-3.9-3.9c-0.1-0.1-0.3-0.2-0.5-0.2h-3.2V3.1c0-1.5-1.2-2.7-2.7-2.7H3.2c-1.5,0-2.7,1.2-2.7,2.7v9.8 c0,1.5,1.2,2.7,2.7,2.7h0.5c0.3,1.7,1.8,2.9,3.6,2.9c1.8,0,3.3-1.3,3.6-2.9h4.2c0.3,1.7,1.8,2.9,3.6,2.9s3.3-1.3,3.6-2.9h2.5 c0.4,0,0.7-0.3,0.7-0.7V7.8C25.5,7.6,25.4,7.5,25.3,7.3z M20.5,4.6L23,7.1h-5.3V4.6H20.5z M2,12.9V3.1c0-0.7,0.6-1.2,1.2-1.2H15 c0.7,0,1.2,0.6,1.2,1.2v9.1c-0.6,0.5-0.9,1.2-1.1,2h-4.2c-0.3-1.7-1.8-2.9-3.6-2.9s-3.3,1.3-3.6,2.9H3.2C2.5,14.2,2,13.6,2,12.9z  M7.3,17.1c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2C9.5,16.1,8.5,17.1,7.3,17.1z M18.7,17.1 c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2C20.9,16.1,19.9,17.1,18.7,17.1z M22.3,14.2 c-0.3-1.7-1.8-2.9-3.6-2.9c-0.4,0-0.7,0.1-1,0.1V8.6H24v5.6L22.3,14.2L22.3,14.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoDespacho);
export default __webpack_public_path__ + "static/media/icono_despacho.a7e679a2a4a22cce89c240920f0427a2.svg";
export { ForwardRef as ReactComponent };